import React from 'react';
import { l10n } from '../../i18n/Localization';
import Sc2Character from '../../models/characters/Sc2Character';
import Sc2CharacterView from './starcraft_2/Sc2CharacterView';

const CharacterView = (props) => {
    const { character, showingToOwner } = props;

    if (character instanceof Sc2Character) {
        return (
            <Sc2CharacterView sc2Character={character} showingToOwner={showingToOwner} />
        );
    } else {
        return (
            <div>{l10n.characterView.characterInvalid}</div>
        );
    }
};

export default CharacterView;
